import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Helper } from "../../helpers/helper";
import { BASE_BACKEND, ENDPOINT } from "../../http/api";
import { User } from "../../models/user.model";

@Injectable()
export class UserService {
  baseurl: string;
  baseAvantia: string;
  companyId = "1";

  constructor(private http: HttpClient) {
    this.baseurl = `${BASE_BACKEND}${ENDPOINT.user.base}`;
  }

  getUsers(params): Observable<User[]> {
    return this.http.get(`${this.baseurl}${ENDPOINT.user.list}${params}`).pipe(
      map((users: User[]) => users),
      catchError(Helper.handleError)
    );
  }

  registerUser(data: User): Observable<User> {
    return this.http
      .post(`${this.baseurl}${ENDPOINT.user.register}`, { ...data })
      .pipe(
        map((response: User) => response),
        catchError(Helper.handleError)
      );
  }

  updateUser(data: User): Observable<User> {
    return this.http
      .put(`${this.baseurl}${ENDPOINT.user.update}`, { ...data })
      .pipe(
        map((response: User) => response),
        catchError(Helper.handleError)
      );
  }

  searchUser(userId: any): Promise<User> {
    return this.http
      .get(`${this.baseurl}${ENDPOINT.user.search}${userId}`)
      .toPromise()
      .then((response: User) => response)
      .catch((response: any) => response);
  }

  deleteUser(userId: number): Observable<User> {
    return this.http
      .delete(`${this.baseurl}${ENDPOINT.user.delete}${userId}`)
      .pipe(
        map((user: User) => user),
        catchError(Helper.handleError)
      );
  }

  searchUserFull(queryParams: string) {
    return this.http
      .get(`${this.baseurl}${ENDPOINT.user.fullsearch}${queryParams}`)
      .toPromise()
      .then((response: any) => response)
      .catch((response: any) => response);
  }

  changePassword(data: any) {
    return this.http
      .post(`${this.baseurl}${ENDPOINT.user.changePassword}`, { ...data })
      .pipe(
        map((user: User) => user),
        catchError(Helper.handleError)
      );
  }

  changeStatus(id: any) {
    return this.http
      .put(`${this.baseurl}${ENDPOINT.user.changeStatus}/${id}`, {})
      .pipe(
        map((res) => res),
        catchError(Helper.handleError)
      );
  }
}
